import { createSelector } from "reselect";

import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";
import { PolygonType } from "../Models/Maps/Enums/PolygonType";
import { IPolygon } from "../Models/Maps/IPolygon";
import { IMobilyticsScenarioFormState } from "../Pages/Apps/Mobilytics/SubmitMobilyticsLogic";
import { IRootReducer } from "../Reducers/RootReducer";
import { CreateCustomLocationParameters, LocationDetailsParameters } from "../Types/MobilyticsActionTypes";

export const customReportTitleSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.customReportTitle,
    (customReportTitle: string) => customReportTitle
);

export const savedPolygonsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.savedPolygons,
    (polygons: IPolygon[]) => polygons
);

export const inProcessPolygonSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.inProcessPolygon,
    (poly: IPolygon) => poly
);

export const isDrawingPolygonSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isDrawingPolygon,
    (isDrawingPolygon: boolean) => isDrawingPolygon
);

export const isLoadingMobilyticsReportSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isLoadingMobilyticsReport,
    (isLoadingMobilyticsReport: boolean) => isLoadingMobilyticsReport
);

export const isSearchingForNewLocationSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isSearchingForNewLocation,
    (isSearchingForNewLocation: boolean) => isSearchingForNewLocation
);

export const mobilyticsSearchedLocationSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.searchedLocation,
    (searchedLocation: string) => searchedLocation
);

export const locationDetailsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.locationDetailsParameters,
    (locationDetailsParameters: LocationDetailsParameters) => locationDetailsParameters
);

export const isCreatingCustomLocationSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isCreatingCustomLocation,
    (isCreatingCustomLocation: boolean) => isCreatingCustomLocation
);

export const isViewingLocationDetailsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isViewingLocationDetails,
    (isViewingLocationDetails: boolean) => isViewingLocationDetails
);

export const shouldShowEndOfReportScreenSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.shouldShowEndOfReportScreen,
    (shouldShowEndOfReportScreen: boolean) => shouldShowEndOfReportScreen
);

export const isRedirectedFromCreateCustomLocationSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isRedirectedFromCreateCustomLocation,
    (isRedirectedFromCreateCustomLocation: boolean) => isRedirectedFromCreateCustomLocation
);

export const drawPolygonTypeSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.drawPolygonType,
    (drawPolygonType: PolygonType) => drawPolygonType
);

export const scenarioFormStatesSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.scenarioFormStates,
    (scenarioFormStates: IMobilyticsScenarioFormState[]) => scenarioFormStates
);

export const mobilyticsSearchedLocationNameSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.searchedLocationName,
    (searchedLocationName: string) => searchedLocationName,
);

export const mobilyticsSearchedLocationIndexSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.searchedLocationIndex,
    (searchedLocationIndex: number) => searchedLocationIndex,
);

export const mostRecentlySubmittedMobilyticsReportSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.mostRecentlySubmittedReport,
    (report: IGCPBigQueryJob[]) => report,
);

export const nearbyLocationsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.nearbyLocations,
    (locations: ISafegraphLocation[]) => locations,
);

export const similarLocationsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.similarLocations,
    (locations: ISafegraphLocation[]) => locations,
);

export const selectedSafegraphLocationSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.selectedSafegraphLocation,
    (location: ISafegraphLocation) => location,
);

export const firstScenarioSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.scenarioFormStates,
    (scenarioFormStates: IMobilyticsScenarioFormState[]) => scenarioFormStates[0]
);

export const createCustomLocationParametersSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.createCustomLocationParameters,
    (createCustomLocationParameters: CreateCustomLocationParameters) => createCustomLocationParameters
);

export const isLoadingLocationsSelector = createSelector(
    (state: IRootReducer) => state.mobilyticsReducer.isLoadingLocations,
    (isLoading: boolean) => isLoading
);